import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { getClubList } from '../../../store/selectors';
import { toggleCareerMenu } from '../../../store/actionCreators/career';
import '../../../assets/stylesheets/CareerSlide/CareerMenu.scss';
import { faChevronCircleLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome/index';
import defaults from '../../../config/career';
  
const { gameTypes } = defaults;

const CareerMenuRow = ({ selectedGame, setSelectedGame, selectedClub, setSelectedClub, club }) => {
    const { t } = useTranslation();
    const [selectedBefore, setSelectedBefore] = useState(selectedGame);
    const detailedSelection = useCallback((type, club) => {
        let exists = selectedGame.find( item => item.label === type.label );
        let localList;

        if (selectedClub.clubId === club.clubId) {
            if (type.label === 'all') {
                localList = [];
            } else {
                localList = selectedGame.filter( item => item.label !== "all" );
            }        
            if (exists) {
                localList = selectedGame.filter((item) => { return item.label !== type.label });
            } else {
                localList.push(type);
            }
            
            if (localList.length === 0 || localList.length === 3) {
                localList = [gameTypes[0]];
            }
        } else {
            localList = [];
            localList.push(type);
        }
        setSelectedGame([...localList]);
        setSelectedClub(club);
    });

    return (
        <div className={`clubEntry`}>
            <span className="clubName">{club.clubName}</span>
            <div className="filtersList">
                {
                    gameTypes.map((type, index) => 
                        <button 
                            key={index}
                            className={`${((selectedGame[0] && type) && ((selectedGame.find(game => game.label === type.label)) && (club.clubId === selectedClub.clubId))) ? 'activeSelection' : ''}`}
                            onClick={() => {
                                detailedSelection(type, club)
                            }}>{t(`career.menuRow.${type.label}`)}</button>
                    )
                }
            </div>
        </div>
    )
};

export default CareerMenuRow;